export default "__VITE_ASSET__dbbec187__"